import React from 'react'
import { M_Table } from 'src/components/M_Components'

export const ExtraFuelTax = ({ roles }) => {

    return (
        <M_Table entityName={'ExtraFuelTax'} filtersOnTable rolePermissions={roles} />
    )
}